import $ from 'jquery';

$.addInit(function(context){
	$('.b-map', context).each(function(){

		var component = $(this);
		var lazy = component.data('lazy');

		function init () {
			var balloonTemplate = component.find('.b-map-balloonTemplate').html();
			var componentZoom = component.data('zoom') || 15;

			// Creating an instance of the map and binding it to the created container.
			var map = new ymaps.Map(component[0], {
				center: component.data('center'),
				zoom: componentZoom,
				controls: []
			}, {
				zoomControlFloat: 'right',
				searchControlProvider: 'yandex#search'
			});

			var clusterer = new ymaps.Clusterer({
				clusterIconLayout: "default#pieChart",
				clusterIconPieChartRadius: 30,
				clusterIconPieChartCoreRadius: 20,
				clusterIconPieChartStrokeWidth:2,
				hasBalloon: false,
				gridSize: 80
			});

			// Creating a balloon layout
			var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
				balloonTemplate,
				{
					/**
					 * Builds an instance of a layout based on a template and adds it to the parent HTML element.
					 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
					 * @function
					 * @name build
					 */
					build: function () {
						this.constructor.superclass.build.call(this);

						this._$element = $('.b-mapBalloon', this.getParentElement());

						// this.applyElementOffset();
					},

					/**
					 * Removes the layout contents from DOM.
					 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
					 * @function
					 * @name clear
					 */
					clear: function () {
						this.constructor.superclass.clear.call(this);
					},

					/**
					 * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
					 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
					 * @function
					 * @name onSublayoutSizeChange
					 */
					onSublayoutSizeChange: function () {
						MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

						if(!this._isElement(this._$element)) {
							return;
						}

						this.applyElementOffset();

						this.events.fire('shapechange');
					},

					applyElementOffset: function() {
						// console.log('applyElementOffset', this._$element[0].offsetWidth, this._$element[0].offsetHeight);
						// this._$element.css({
						// 	left: -(this._$element[0].offsetWidth / 2),
						// 	top: -(this._$element[0].offsetHeight // 60
						// 		+ this._$element.find('.b-mapBalloon-arrow')[0].offsetHeight - 12) // -12

							// top: -48px
						// });
					},

					onCloseClick: function(e) {
						e.preventDefault();

						this.events.fire('userclose');
					},

					getShape: function () {
						if(!this._isElement(this._$element)) {
							return MyBalloonLayout.superclass.getShape.call(this);
						}

						var position = this._$element.position();

						return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
							[position.left, position.top], [
								position.left + this._$element[0].offsetWidth,
								position.top + this._$element[0].offsetHeight + this._$element.find('.b-mapBalloon-arrow')[0].offsetHeight
							]
						]));
					},

					_isElement: function (element) {
						return element && element[0] && element.find('.b-mapBalloon-arrow')[0];
					}
				}
			);

			function createPlacemark(params) {
				return new ymaps.Placemark(
					params.coord,
					{
						balloonContent: params.content,
						zoom: params.zoom,
						place: params.place,
					},
					{
						iconLayout: 'default#image',
						iconImageHref: params.icon || undefined,
						iconImageSize: params.sizeIcon || undefined,
						iconColor: params.iconColor || undefined,
						hideIconOnBalloonOpen: true,
						balloonShadow: false,
						balloonLayout: MyBalloonLayout,
						balloonPanelMaxMapArea: 0,
						preset: params.preset,
						draggable:false
					}
				);
			}

			var placemarks = component.find('.b-map-balloonContent').get().map(function(el) {
				var data = $(el).data();

				return createPlacemark({
					coord: data.coord,
					content: el.innerHTML,
					icon: data.icon,
					sizeIcon: data.sizeIcon,
					iconColor: data.iconColor,
					zoom: data.zoom,
					place: data.place
				});
			});

			placemarks.forEach(function(placemark) {
				clusterer.add(placemark);
			});

			map.geoObjects.add(clusterer);

			component.on('setAddress', function (e, coord) {
				var placemark = placemarks.find(function (n) {
					return n.geometry.getCoordinates().every(function (m, i) {
						return m === coord[i];
					});
				});

				var placemarkZoom = placemark.properties.get('zoom') || componentZoom;

				map.panTo(coord, {
					duration: 500,
					flying: true,
				})
					.then(function() {
						return map.setZoom(placemarkZoom, {
							duration: 500,
						});
					})
			});

			component.on('center', function(e, coord) {
				map.panTo(coord, {
					flying: true
				});
			});

			component.on('draw', function() {
				map.container.fitToViewport();
			})

			map.events.add('click', function (e) {
				map.balloon.close();
			});

			map.behaviors.disable('scrollZoom');
			map.events.add('click', function(){
				map.behaviors.enable('scrollZoom')
			});

			map.controls.add(new ymaps.control.ZoomControl(), {
				size: 'small',
				float: 'none',
				position: {
					top: '40px',
					left: '10px'
				}
			});

			if (placemarks.length > 1) {
				// map.setBounds(map.geoObjects.getBounds(), {checkZoomRange: false});
			}

			component.trigger('init');
		}

		if (lazy === true) {
			component.one('draw', function() {
				ymaps.load(init);
			});
		} else {
			ymaps.load(init);
		}
	});
});
